import { AccountConstants } from './../layout/store/constants';
import { useQuery } from '@redux-requests/react';

const useAuth = (): boolean => {
  const { data } = useQuery({ type: AccountConstants.ACCOUNT });
  return Boolean(data?.email);
};

export default useAuth;
